import {
    observable,
    action,
    computed,
    when,
    reaction,
} from 'mobx';

import { myConst, myMap } from "@config/";
import { loadingEnd } from "@utils/ui";


export default class AppStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
        if (localStorage.UseOrEmpty) {
            this.appState.UseOrEmpty = localStorage.UseOrEmpty.toString() === "true" ? true : false;
        }
        when(() => this.initComplete, () => {
            console.green('watch 到全部 ok 啦');
            loadingEnd();
        });

        reaction(() => this.locState.watchLoc, (watchLoc) => {
            let id = this.locState.watchLocId;
            if (watchLoc) {
                console.red('开始监听定位');
                clearInterval(id);
                this.locState.watchLocId = setInterval(() => {
                    myMap.geolocation.getLoc();
                }, myConst.loc.watchCycle);
            } else {
                console.red('停止监听定位');
                clearInterval(id);
            }
        }, { name: 'watchLoc', fireImmediately: true });

    }

    @observable initState = {
        page: false,
    }

    @observable locState = {
        isLocIng: false, // 是否正在定位
        locState: false,
        watchLoc: false,
        watchLocId: 0,
    }
    @observable appState = {
        UseOrEmpty: true, // true 显示空位
        devMode: false,
        searchShow: false,
    }

    @computed get initComplete() {
        return this.initState.page;
    }
    @action.bound firstPageIsOk() {
        this.initState.page = true;
    }

    @action.bound changeWatchLoc(options) {
        if (!options) {
            this.locState.watchLoc = !this.locState.watchLoc;
        } else {
            this.locState.watchLoc = options.state;
        }
    }
    @action.bound changeIsLocIng(options) {
        // 定位成功
        this.locState.isLocIng = options;
    }

    @action.bound changeLocState(options) {
        // 定位成功
        this.locState.succLoc = options;
    }

    @action.bound toggleSearchShow(options) {
        if (options && options.on_off) {
            this.appState.searchShow = options.on_off;
        } else {
            this.appState.searchShow = !this.appState.searchShow;
        }
        if (this.appState.searchShow) {
            this.rootStore.mapStore.toggleInfoBox({ on_off: false, source: 'toogleSearch' });
            window.mdui(".BMap_noprint.anchorTR").removeClass("hide");
            window.mdui("#search .his_item.delete").removeClass("delete");
        } else {
            window.mdui(".BMap_noprint.anchorTR").removeClass("hide");
        }
    }
    @action.bound toggleDevMode(options) {
        if (!options) {
            this.appState.devMode = !this.appState.devMode;
        } else {
            this.appState.devMode = options.on_off;
        }
    }
    @action.bound toggleUseOrEmpty(options) {
        this.appState.UseOrEmpty = options.value;
        localStorage.UseOrEmpty = options.value;
    }
}
